"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.revisions = exports.initialState = void 0;
const _revisionsReducers = require("../../modules/revisions/reducers");
const revisionsReducers = _revisionsReducers.default('files');
exports.initialState = revisionsReducers.initialState;
exports.revisions = revisionsReducers.reducer;
//# sourceMappingURL=index.js.map